export const text = {
  MIN_VALID_DOB: '1901-01-01',
  SEARCH_PLACEHOLDER: 'Search by name, MRN, phone, email, or DOB',
  RECENTLY_VIEWED_TITLE: 'Recently viewed',
  RECENTLY_VIEWED_SUBTITLE: 'Jump back into a recently viewed chart, or start a new search',
  NO_CHARTS_VIEWED_SUBTITLE: 'No charts viewed yet',
  SEARCH_RESULTS_TITLE: 'Search results',
  SEARCH_PROMPT_TITLE: 'Search patients',
  SEARCH_PROMPT_SUBTITLE: 'Results appear as you type.',
  NO_RESULTS_SUBTITLE:
    'Check the spelling, or try searching by MRN, phone number, or email instead. A date of birth can be combined with any of them.',
  MERGE_ACCOUNTS: 'Merge accounts',
  // Shown beside the free text in the results header so it is visible that a
  // typed date was read as a date of birth rather than searched for as text.
  SEARCH_DOB_PREFIX: 'DOB',
  SEARCH_TERM_SEPARATOR: ' · ',
  INVALID_DOB_MESSAGE: 'is not a valid date of birth. Try MM/DD/YYYY.',
}

export const count = {
  GET_PATIENTS_LIST_COUNT: 20,
  SEARCH_VALUE_MIN_LENGTH: 3,
}

export const routeParam = {
  SEARCH_VALUE: 'search',
}
